import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Fab,
  Tooltip,
  useMediaQuery,
  Button,
} from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SettingsIcon from "@mui/icons-material/Settings";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIcon from "@mui/icons-material/Phone";
import smbfavicon from "../assets/img/elegant_prime logo.png";
import { useDispatch, useSelector } from "react-redux";
import Swith from "../assets/Switch.png";
import ClockIcon from "../assets/img/icons/clock_icon.png";
import CalendarIcon from "../assets/img/icons/calendar_icon.png";
import LogoutIcon from "../assets/img/icons/logout_icon.png";
import SwitchIcon from "../assets/img/icons/switchIcon.png";
import SettingIcon from "../assets/img/icons/setting_icon.png";
import LogOutPop from "./logoutPop";
import dayjs from "dayjs";
import { setchangeRoll } from "../app/store/reducer";
import { useLocation, useNavigate } from "react-router";
import { routePath } from "../constants/routePath";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@emotion/react";
const NavbarDashboard = ({ setDrawerShowSideBar, setsideBarDrawer }) => {
  const location = useLocation();
  const userDetail = useSelector((state) => state.reducer.userDetail);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeUserDetails = useSelector((state) => state.reducer.userDetail);

  const [open, setOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer); // cleanup on unmount
  }, []);
  const theme = useTheme();
  const isAbove1440 = useMediaQuery("(min-width:1440px)");
  return (
    <Grid container>
      <Grid
        item
        xs={6}
        sm={2}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#FFFFFF",
        }}
      >
        <Box
          // width="65px"

          component="img"
          src={smbfavicon}
          alt="Elegant Prime"
          // onClick={() => navigate(routePath.LANDINGPAGE)}
          sx={{
            cursor: "pointer",
            // height: { sm:48, xs: "" },
            width: { sm: "100%", xs: "100%" },
            textAlign: "left",
          }}
        />
        {/* <img src={} alt="Elegant Prime" height={48} /> */}
      </Grid>
      <Grid
        item
        xs={10}
        sm={10}
        md={10}
        sx={{
          display: { xs: "none", sm: "block" },
        }}
      >
        <Box
          sx={{
            backgroundColor: "#01008B",
            color: "white",
            py: "20px",
            px: userDetail?.role !== "Admin" ? "20px" : "0px",
            boxShadow: 1,
          }}
        >
          <Grid
            container
            sx={{
              px: {
                lg: userDetail?.role !== "Admin" ? 3 : 1,
                md: 1,
                sm: 1,
                xs: 1,
              },
            }}
          >
            <Grid
              xs={1}
              sx={{
                display: { sm: "flex", xs: "none" },
              }}
            >
              {location.pathname.split("/")[
                location.pathname.split("/").length - 1
              ] != "admin" &&
                location.pathname.split("/")[
                  location.pathname.split("/").length - 1
                ] != "advertisementTools" &&
                location.pathname.split("/")[
                  location.pathname.split("/").length - 1
                ] != "rechargeTools" &&
                location.pathname.split("/")[
                  location.pathname.split("/").length - 1
                ] != "supportTools" && (
                  <Box
                    component={"img"}
                    src={activeUserDetails?.logoPath}
                    sx={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                )}
            </Grid>

            <Grid
              xs={5}
              sm={4}
              md={2}
              lg={3}
              sx={{
                display: {
                  sm: "flex",
                  xs: "none",
                  justifyContent: "center",
                  alignItems: "center",
                },
                marginRight: { sm: "20px", md: "0px" },
              }}
            >
              {location.pathname.split("/")[
                location.pathname.split("/").length - 1
              ] != "admin" &&
                location.pathname.split("/")[
                  location.pathname.split("/").length - 1
                ] != "advertisementTools" &&
                location.pathname.split("/")[
                  location.pathname.split("/").length - 1
                ] != "rechargeTools" &&
                location.pathname.split("/")[
                  location.pathname.split("/").length - 1
                ] != "supportTools" &&
                userDetail?.role !== "Admin" && (
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {activeUserDetails?.myBusinessName}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Branch: {activeUserDetails?.branchName}
                    </Typography>
                  </Box>
                )}
            </Grid>
            {userDetail?.role !== "Admin" && (
              <Grid
                xs={2}
                sm={1}
                md={3}
                lg={isAbove1440 ? 4 : 3}
                sx={{
                  display: { sm: "flex", xs: "none" },
                  justifyContent: "right",

                  alignItems: "center",
                }}
              >
                {location.pathname.split("/")[
                  location.pathname.split("/").length - 1
                ] != "admin" &&
                  location.pathname.split("/")[
                    location.pathname.split("/").length - 1
                  ] != "advertisementTools" &&
                  location.pathname.split("/")[
                    location.pathname.split("/").length - 1
                  ] != "rechargeTools" &&
                  location.pathname.split("/")[
                    location.pathname.split("/").length - 1
                  ] != "supportTools" && (
                    <Typography
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontFamily: "'Montserrat', sans-serif",
                      }}
                    >
                      <PhoneIcon
                        fontSize="small"
                        sx={{
                          marginRight: "4px",
                        }}
                      />{" "}
                      {activeUserDetails?.mobileNumber}
                    </Typography>
                  )}
              </Grid>
            )}

            <Grid
              xs={1.5}
              sm={4}
              md={3}
              lg={2}
              sx={{
                display: { sm: "flex", xs: "none" },
                margin: { md: "0 40px", sm: "0 10px" },
                marginTop: { sm: "0px", xs: "10px" },
                justifyContent: "space-between",
              }}
            >
              {userDetail?.role !== "Admin" && (
                <Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    <Box
                      component="img"
                      src={CalendarIcon}
                      alt="CalendarIcon"
                      sx={{
                        height: { sm: 15, md: 20 }, // responsive height
                        width: "auto", // optional, keeps image aspect ratio
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "12px", md: "15px" },
                      }}
                    >
                      {dayjs().format("MMM-DD-YYYY")}
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    <Box
                      component="img"
                      src={ClockIcon}
                      alt="ClockIcon"
                      sx={{
                        height: { sm: 15, md: 20 }, // responsive height
                        width: "auto", // optional, keeps image aspect ratio
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "12px", md: "15px" },
                      }}
                    >
                      {" "}
                      {currentTime.toLocaleTimeString()}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Grid>

            <Grid
              item
              sm={1}
              sx={{
                display: { md: "flex", sm: "flex", xs: "none" },
                marginLeft:
                  userDetail?.role !== "Admin"
                    ? "0%"
                    : { sm: "90%", md: "90%", lg: "32%", xl: "34%" },
                justifyContent: "right",
              }}
            >
              <Box
                sx={{
                  // marginLeft: userDetail?.role !== "Admin" ? "34%" : "0%",
                  display: { md: "flex", sm: "flex", xs: "none" },
                }}
              >
                {userDetail?.role !== "Admin" && (
                  <Box
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate(routePath.LANDINGPAGE);
                      dispatch(setchangeRoll("customer"));
                    }}
                  >
                    {/* <img src={SwitchIcon} alt="SwitchIcon" height={40} /> */}
                    <Button
                      variant="contained"
                      disableElevation
                      sx={{
                        background:
                          "linear-gradient(90deg, #3f00b5 0%, #9c00af 50%, #f500a2 100%)",
                        borderRadius: "50px",
                        py: { xs: "0px", sm: "8px" },
                        px: "14px",
                        textTransform: "none",
                        fontSize: { xs: "8px", sm: "8px", md: "12px" },

                        fontWeight: 700,
                        fontFamily:
                          '"Roboto", "Helvetica", "Arial", sans-serif',
                        color: "#ffffff",
                        "&:hover": {
                          background:
                            "linear-gradient(90deg, #320091 0%, #7d008c 50%, #c40082 100%)",
                          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                        },
                        transition: "all 0.3s ease-in-out",
                      }}
                      // onClick={() => {
                      //   navigate(routePath.LANDINGPAGE);
                      //   dispatch(setchangeRoll("customer"));
                      // }}
                    >
                      MarketPlace
                    </Button>
                  </Box>
                )}
                {userDetail?.role !== "Admin" && (
                  <Box
                    id={"setting-button"}
                    sx={{ cursor: "pointer" }}
                    onClick={(e) => {
                      setDrawerShowSideBar(true);
                    }}
                  >
                    <img src={SettingIcon} alt="SettingIcon" height={40} />
                  </Box>
                )}
                {(userDetail !== "dashboard" ||
                  userDetail?.role !== "Admin") && (
                  <Box
                    sx={{
                      cursor: "pointer",
                      // marginLeft: userDetail?.role !== "Admin" ? "34%" : "0%",
                    }}
                    onClick={() => {
                      setOpen(true);
                    }}
                  >
                    <img src={LogoutIcon} alt="LogoutIcon" height={40} />
                  </Box>
                )}
                <Box
                  sx={{
                    cursor: "pointer",
                    display: { sm: "none", xs: "block" },
                  }}
                  onClick={() => {
                    setsideBarDrawer(true);
                  }}
                >
                  <MenuIcon height={40} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid
        xs={6}
        sm={1}
        // gap={1}
        sx={{
          backgroundColor: "#01008B",
          color: "white",
          padding: "7px",
          boxShadow: 1,
          display: { md: "none", sm: "none", xs: "flex" },
          justifyContent: "right",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        {userDetail?.role !== "Admin" && (
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => {
              navigate(routePath.LANDINGPAGE);
              dispatch(setchangeRoll("customer"));
            }}
          >
            {/* <img src={SwitchIcon} alt="SwitchIcon" height={40} /> */}
            <Button
              variant="contained"
              disableElevation
              sx={{
                background:
                  "linear-gradient(90deg, #3f00b5 0%, #9c00af 50%, #f500a2 100%)",
                borderRadius: "50px",
                py: { xs: "8px", sm: "8px" },
                px: "14px",
                textTransform: "none",
                fontSize: { xs: "8px", sm: "8px", md: "12px" },

                fontWeight: 700,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                color: "#ffffff",
                "&:hover": {
                  background:
                    "linear-gradient(90deg, #320091 0%, #7d008c 50%, #c40082 100%)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                },
                transition: "all 0.3s ease-in-out",
              }}
              // onClick={() => {
              //   navigate(routePath.LANDINGPAGE);
              //   dispatch(setchangeRoll("customer"));
              // }}
            >
              MarketPlace
            </Button>
          </Box>
        )}
        {userDetail?.role !== "Admin" && (
          <Box
            id={"setting-button"}
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              setDrawerShowSideBar(true);
            }}
          >
            <img src={SettingIcon} alt="SettingIcon" height={40} />
          </Box>
        )}
        {(userDetail !== "dashboard" || userDetail?.role !== "Admin") && (
          <Box
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setOpen(true);
            }}
          >
            <img src={LogoutIcon} alt="LogoutIcon" height={40} />
          </Box>
        )}
        <Box
          sx={{ cursor: "pointer", display: { sm: "none", xs: "block" } }}
          onClick={() => {
            setsideBarDrawer(true);
          }}
        >
          <MenuIcon height={40} />
        </Box>
      </Grid>
      <LogOutPop open={open} setOpen={setOpen} />
    </Grid>
  );
};

export default NavbarDashboard;
